import { CellContext } from '@tanstack/react-table';
import { CampaignTableRow } from '../types';
import Skeleton from 'react-loading-skeleton';
import { getTableMetaHelper } from '@round/ui-kit';
import { CampaignsTableMeta } from 'Modules/Plans/Campaigns/types';
import { Tooltip, assets } from '@round/whitelabel-ui';
import styles from '../PublicReportCampaignTable.module.css';

const { InfoCircleFilled: InfoIcon } = assets;

const getTableMeta = getTableMetaHelper<CampaignsTableMeta>();

type Props = CellContext<CampaignTableRow, any>;

const PostsCell = ({ row: { original }, table }: Props) => {
    const { isLoading, getIsCampaignStatsLoading } = getTableMeta(table);
    const { stats, managed_by, microwave_target_post_count } = original;

    if (isLoading || getIsCampaignStatsLoading?.(original)) {
        return <Skeleton />;
    }

    if (!stats) {
        return '-';
    }

    const { post_count: postCount, live_post_count: livePostCount } = stats;
    const outOfPosts = managed_by !== 'microwave' ? postCount : microwave_target_post_count;

    const postsCountText = outOfPosts === 0 ? 0 : `${livePostCount}/${outOfPosts}`;
    return (
        <span className={styles.postCount}>
            {postsCountText}
            {managed_by === 'microwave' ? (
                <Tooltip.Root>
                    {(anchor, setAnchor) => (
                        <>
                            <InfoIcon className={styles.infoIcon} ref={setAnchor} />
                            <Tooltip className={styles.tooltip} anchorElement={anchor}>
                                <Tooltip.Title>Posts Live / Posts Target Count</Tooltip.Title>
                                <Tooltip.Body>
                                    Micro.wav campaigns use a target post count to calculate the progress of a campaign
                                </Tooltip.Body>
                            </Tooltip>
                        </>
                    )}
                </Tooltip.Root>
            ) : null}
        </span>
    );
};

export default PostsCell;
